<template>
  <div
    class="asc-fleet-fault-msg-wrapper"
    data-automation-id="wrapper_fleet_fault_msgs"
  >
    <template v-if="loading">
      <asc-spinner-wrapper loading></asc-spinner-wrapper>
    </template>
    <template v-if="!loading">
      <asc-tab id="tabsWithGrayBackground" v-model="tabIndex">
        <asc-tab-title title="Fault Msg Trend Analysis" />
        <asc-tab-title title="Fault Reports By Flight" />
      </asc-tab>
      <asc-tab-body :value="tabIndex">
        <asc-tab-item>
          <asc-fleet-fault-msg-tab-1-wrapper
            :loading="loading"
            :fault-msg-default-filter-options="faultMsgDefaultFilterOptions"
            :fault-msg-count-by-tail-data="faultMsgCountByTailData"
            :fault-msg-count-by-ata-chapter-data="faultMsgCountByAtaChapterData"
            :fault-msg-count-by-para-data="faultMsgCountByParaData"
            :fault-msg-codes-grid-columns="faultMsgCodesGridColumns"
            :fault-msg-codes-grid-data="faultMsgCodesGridData"
            :on-fault-msg-filters-change="onFaultMsgFiltersChange"
            :on-fault-msg-tail-change="onFaultMsgTailChange"
            :on-fault-msg-ata-chapter-change="onFaultMsgAtaChapterChange"
            :on-fault-msg-para-change="onFaultMsgParaChange"
            :on-open-raw-report="onOpenRawReport"
            :on-visualize="onVisualize"
          ></asc-fleet-fault-msg-tab-1-wrapper>
        </asc-tab-item>
        <asc-tab-item>
          <asc-fleet-fault-msg-tab-2-wrapper
            :loading="loading"
            :fault-reports-default-filter-options="
              faultReportsDefaultFilterOptions
            "
            :fault-reports-by-flight-data="faultReportsByFlightData"
            :on-fault-reports-filters-change="onFaultReportsFiltersChange"
            :on-open-raw-report="onOpenRawReport"
            :on-view-details="onViewDetails"
            :on-visualize="onVisualize"
          ></asc-fleet-fault-msg-tab-2-wrapper>
        </asc-tab-item>
      </asc-tab-body>
    </template>
  </div>
</template>

<script>
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscFleetFaultMsgTab1Wrapper from './AscFleetFaultMsgTab1Wrapper.vue'
import AscFleetFaultMsgTab2Wrapper from './AscFleetFaultMsgTab2Wrapper.vue'
import AscTab from '@/components/atoms/AscTab'
import AscTabTitle from '@/components/atoms/AscTabTitle'
import AscTabBody from '@/components/atoms/AscTabBody'
import AscTabItem from '@/components/atoms/AscTabItem'

export default {
  name: 'AscFleetFaultMsgWrapper',

  components: {
    AscSpinnerWrapper,
    AscFleetFaultMsgTab1Wrapper,
    AscFleetFaultMsgTab2Wrapper,
    AscTab,
    AscTabTitle,
    AscTabBody,
    AscTabItem,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    faultMsgDefaultFilterOptions: {
      type: Array,
      default: () => [],
    },
    faultMsgCountByTailData: {
      type: Array,
      default: () => [],
    },
    faultMsgCountByAtaChapterData: {
      type: Array,
      default: () => [],
    },
    faultMsgCountByParaData: {
      type: Array,
      default: () => [],
    },
    faultMsgCodesGridColumns: {
      type: Array,
      default: () => [],
    },
    faultMsgCodesGridData: {
      type: Array,
      default: () => [],
    },
    faultReportsDefaultFilterOptions: {
      type: Array,
      default: () => [],
    },
    faultReportsByFlightData: {
      type: Array,
      default: () => [],
    },
    onFaultMsgFiltersChange: {
      type: Function,
      default: () => {},
    },
    onFaultMsgTailChange: {
      type: Function,
      default: () => {},
    },
    onFaultMsgAtaChapterChange: {
      type: Function,
      default: () => {},
    },
    onFaultMsgParaChange: {
      type: Function,
      default: () => {},
    },
    onFaultReportsFiltersChange: {
      type: Function,
      default: () => {},
    },
    onOpenRawReport: {
      type: Function,
      default: () => {},
    },
    onViewDetails: {
      type: Function,
      default: () => {},
    },
    onVisualize: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      tabIndex: 0,
    }
  },
}
</script>

<style lang="scss">
.asc-fleet-fault-msg-wrapper {
  padding: 16px;
  background-color: $primary-white;

  .asc-tab__content--primary,
  .asc-tab__content--secondary {
    padding: 16px 0 0 0;
  }

  .asc-fleet-fault-msg-wrapper--content {
    &-tail {
      margin: 16px 0;
      padding: 8px;
      border: 1px solid $gray-300;
    }
  }

  .asc-fleet-fault-msg-wrapper---content-chart {
    display: flex;
  }

  .asc-fleet-fault-msg-wrapper---content-chart-para {
    width: 50%;
    margin: 0 0 0 10px;
    padding: 8px;
    border: 1px solid $gray-300;
  }

  .asc-fleet-fault-msg-wrapper---content-chart-ataChapter {
    width: 50%;
    margin: 0 10px 0 0;
    padding: 8px;
    border: 1px solid $gray-300;
  }

  #tabsWithGrayBackground .v-tabs-bar__content {
    background-color: $gray-100 !important;
  }
}
</style>
